export const crewConstants = {
  FETCH_CREW_ROLES_LOADING: 'FETCH_CREW_ROLES_LOADING',
  FETCH_CREW_ROLES_SUCCESS: 'FETCH_CREW_ROLES_SUCCESS',
  FETCH_CREW_ROLES_ERROR: 'FETCH_CREW_ROLES_ERROR',

  FETCH_CREW_FOR_BOAT_LOADING: 'FETCH_CREW_FOR_BOAT_LOADING',
  FETCH_CREW_FOR_BOAT_SUCCESS: 'FETCH_CREW_FOR_BOAT_SUCCESS',
  FETCH_CREW_FOR_BOAT_ERROR: 'FETCH_CREW_FOR_BOAT_ERROR',

  FETCH_FAMILIARIZATION_FORM_FOR_BOAT_LOADING: 'FETCH_FAMILIARIZATION_FORM_FOR_BOAT_LOADING',
  FETCH_FAMILIARIZATION_FORM_FOR_BOAT_SUCCESS: 'FETCH_FAMILIARIZATION_FORM_FOR_BOAT_SUCCESS',
  FETCH_FAMILIARIZATION_FORM_FOR_BOAT_ERROR: 'FETCH_FAMILIARIZATION_FORM_FOR_BOAT_ERROR',

  IS_USER_FAMILIARIZED_ON_BOAT_LOADING: 'IS_USER_FAMILIARIZED_ON_BOAT_LOADING',
  IS_USER_FAMILIARIZED_ON_BOAT_SUCCESS: 'IS_USER_FAMILIARIZED_ON_BOAT_SUCCESS',
  IS_USER_FAMILIARIZED_ON_BOAT_ERROR: 'IS_USER_FAMILIARIZED_ON_BOAT_ERROR',

  FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_LOADING: 'FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_LOADING',
  FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_SUCCESS: 'FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_SUCCESS',
  FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_ERROR: 'FETCH_FAMILIARIZED_ADMIN_USERS_ON_BOAT_ERROR',

  APPROVE_FAMILIARIZATION_ON_BOAT_LOADING: 'APPROVE_FAMILIARIZATION_ON_BOAT_LOADING',
  APPROVE_FAMILIARIZATION_ON_BOAT_SUCCESS: 'APPROVE_FAMILIARIZATION_ON_BOAT_SUCCESS',
}
